const decryptedCache = new Map();

export function getDecryptedConversationKeyFromCache(guid) {
  return decryptedCache.get(guid);
}

export function setDecryptedConversationKeyCache(guid, key, iv) {
  decryptedCache.set(guid, { key, iv });
}

export function clearDecryptedConversationKeyCache() {
  decryptedCache.clear();
}
